import React, { useEffect, useState, useContext } from "react";
import { css } from "emotion";
import SpotlightFooter6Step from "./SpotlightFooter6Step";
import SpotlightFooter5Step from "./SpotlightFooter5Step";
import { boxStyles } from "../../styles/theme";
import { BuildContext } from "../../context/BuildSpotlightState";

const FooterContainer = () => {
  const { type, stage } = useContext(BuildContext);

  return (
    <div className={container}>
      <div className="footer">
        <div className="footerCard">
          <div className="footerBar">
            {type === "text" ? (
              <SpotlightFooter5Step currentStep={stage} />
            ) : (
              <SpotlightFooter6Step currentStep={stage} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterContainer;

const container = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .footerCard {
    display: flex;
    align-items: center;
    height: 70px;
  }

  .footer {
    display: flex;
    justify-content: center;
    width: 100%;
    box-shadow: ${boxStyles.boxShadow};
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .footer {
      box-shadow: none;
    }

    .footerCard {
      display: flex;
      justify-content: center;
      width: 420px;
      height: 80px;
      border-radius: ${boxStyles.borderRadius};
      padding: ${boxStyles.standardPadding};
    }
  }

  .footerBar {
    width: 300px;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .footerBar {
      width: 345px;
    }
  }
`;
